import {css} from 'lit';

export default css`

.site-branding {
  --o-media-gutter: var(--o-media-gutter-default, 1rem);
  --o-media-gutter--right: var(--o-media-gutter-default, 1rem);
  --o-media-gutter--left: 0;
  display: flex;
  align-items: flex-start;
  align-items: center;
}
.site-branding__figure {
  margin-right: var(--o-media-gutter--right);
  margin-left: var(--o-media-gutter--left);
}
.site-branding__body {
  display: block;
  flex: 1;
}
.site-branding__body,
.site-branding__body > :last-child {
  margin-bottom: 0;
}
.site-branding--small {
  --o-media-gutter: 0.5rem;
  --o-media-gutter--right: var(--o-media-gutter);
}
.site-branding--large {
  --o-media-gutter: 2rem;
  --o-media-gutter--right: var(--o-media-gutter);
}
.site-branding--rev {
  --o-media-gutter--right: 0;
  --o-media-gutter--left: var(--o-media-gutter, 1rem);
  flex-direction: row-reverse;
}
.site-branding--flush {
  --o-media-gutter--right: 0;
  --o-media-gutter--left: 0;
}
.site-branding__figure {
  margin-right: var(--o-media-gutter--right);
  margin-left: var(--o-media-gutter--left);
}
.site-branding__body {
  display: block;
  flex: 1;
}
.site-branding__body,
.site-branding__body > :last-child {
  margin-bottom: 0;
}
.site-branding__site-name {
  margin-bottom: 0.25rem;
  color: #022851;
  font-size: 1.5rem;
  font-weight: 700;
}
@media (min-width: 992px) {
  .site-branding__site-name {
    font-size: 2rem;
  }
}
.site-branding__site-name a {
  color: #022851;
  text-decoration: none;
}
.site-branding__site-name a:hover, .site-branding__site-name a:focus {
  color: #022851;
  text-decoration: underline;
}
.site-branding__slogan {
  color: #022851;
  font-size: 1.375rem;
  line-height: 1;
}
@media (min-width: 992px) {
  .site-branding__slogan {
    font-size: 1.5rem;
  }
}
.site-branding a {
  color: #022851;
  text-decoration: none;
}
.site-branding a:hover, .site-branding a:focus {
  color: #022851;
  text-decoration: underline;
}

`;